import React from 'react';
import { useTranslation } from 'react-i18next';
import { DistanceUnitFormatter } from 'components/modules/master/formatters';
import { DEFAULT_DISTANCE_UNIT } from 'utils/localization/types';
import { useDistance } from 'hooks/useDistance';
export const ShipmentDistance = ({ distance, routingType, routingConfiguration, fromUnit = 'm', toUnit = DEFAULT_DISTANCE_UNIT, }) => {
    const { t } = useTranslation();
    const { hasDistance, isPcMiler, routerName } = useDistance({
        distance,
        routingType,
        routingConfiguration,
    });
    if (!hasDistance) {
        return null;
    }
    const versionLabel = isPcMiler
        ? routingConfiguration === 'Current'
            ? t('CURRENT')
            : routingConfiguration.replace(/^\D+/g, '')
        : null;
    return (React.createElement("div", { "data-testid": "shipment-distance", className: "flex items-center justify-between mt-4 mb-4" },
        React.createElement("div", null,
            React.createElement("strong", null, t('TOTAL_DISTANCE')),
            ' ',
            React.createElement(DistanceUnitFormatter, { fromUnit: fromUnit, toUnit: toUnit, distance: distance }),
            ' ',
            "(",
            t('ROUTING'),
            ": ",
            routerName,
            isPcMiler && (React.createElement(React.Fragment, null,
                ", ",
                t('VERSION'),
                ": ",
                versionLabel)),
            ")")));
};
